import { render } from "./AttemptWarning.vue?vue&type=template&id=c933b7c2&scoped=true"
import script from "./AttemptWarning.vue?vue&type=script&lang=js"
export * from "./AttemptWarning.vue?vue&type=script&lang=js"

import "./AttemptWarning.vue?vue&type=style&index=0&id=c933b7c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c933b7c2"]])

export default __exports__